<template>
  <span class="def-circle-plus" :class="{ 'def-circle-plus_active': result }">
    <span class="def-circle-plus__item"></span>
    <span class="def-circle-plus__item"></span>
  </span>
</template>

<script>
export default {
  name: 'DefCirclePlus',
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.def-circle-plus {
  display: flex;
  position: relative;
  width: 10px;
  height: 10px;
  align-items: center;
  justify-content: center;
  transition: 0.3s linear all;
  &__item {
    display: block;
    position: absolute;
    height: 2px;
    width: 10px;
    background-color: currentColor;
    border-radius: 50px;
    &:nth-child(2) {
      transform-origin: center;
      transform: rotate(90deg);
      transition: 0.3s linear opacity;
    }
  }
  &_active {
    transform: rotate(180deg);
    span:nth-child(2) {
      opacity: 0;
    }
  }
}
</style>
